/***
*
*   BACKGROUND CHECK COMPONENT
*   Get user Info
*
**********/

import React, { Fragment, useState, useEffect } from 'react';
import Axios from 'axios';
import Style from './audience/audience.module.scss';
import ClassNames from 'classnames';
import { Card, Checkbox } from 'components/lib';
import { Form} from 'components/lib';


export function BackgroundCheck() {
  const [cedula, setCedula]     = useState('');
  const [birthday, setBirthday] = useState('');
  const [status, setStatus]     = useState('');

  // 1) Fetch status for a given cédula
  const fetchStatus = async (id) => {
    try {
      console.log('Fetching status for cedula:', id);
      const res = await Axios.get(`/api/utility/backgroundCheckStatus/${id}`);
      // if your API returns 404 when not found, catch that above with .catch
      console.log('Status response:', res);
      if (res.status === 200 && res.data.status) {
        setStatus(res.data.status);
      }
      else if (res.status === 200 && res.data.data && Object.keys(res.data.data).length === 0) {
        setStatus('not started');
      }
      else console.log('Unexpected response:', res);
    } catch (err) {
      if (err.response && err.response.status === 404) {
        setStatus('not started');
      } else {
        console.error('Status fetch error:', err);
        setStatus('error');
      }
    }
  };

  // 2) Whenever cedula changes, re‑fetch its status
  useEffect(() => {
    if (cedula.trim() === '') {
      setStatus('');
    } else {
      fetchStatus(cedula);
    }
  }, [cedula]);

  // 3) If “in progress”, poll every 2 seconds until status becomes “done”
  useEffect(() => {
    if (status !== 'in progress') return;
    const iv = setInterval(() => fetchStatus(cedula), 2000);
    return () => clearInterval(iv);
  }, [status, cedula]);

  // 4) On button click: start the check or, if done, navigate
  const handleClick = async () => {
    if (status === 'not started') {
      try {
        // Kick off the background check (POST with body)
        const res = await Axios.post('/api/utility/backgroundCheck', {
          params: { id: cedula, birthday }
        });
        if (res.status === 200) {
          setStatus('in progress');
        }
      } catch (err) {
        console.error('Failed to start check:', err);
      }
    } else if (status === 'done') {
      window.location.href = `/background-check/${cedula}`;
    }
  };

  // 5) Decide button label + disabled state
  let btnText, disabled;
  if (!cedula.trim()) {
    btnText  = 'Buscar leads';
    disabled = true;
  } else if (status === 'not started') {
    btnText  = 'Buscar leads';
    disabled = false;
  } else if (status === 'in progress') {
    btnText  = 'In progress…';
    disabled = true;
  } else if (status === 'done') {
    btnText  = 'Ver resultados';
    disabled = false;
  } else {
    btnText  = 'Error';
    disabled = true;
  }

  return (
    <Form
      buttonText={btnText}
      url="/api/user"
      method="PATCH"
      data={{
        cedula: {
          label: 'Cédula de identidad',
          type: 'text',
          required: false,
          value: cedula,
          errorMessage: 'Por favor ingresa tu cédula',
        },
        birthday: {
          label: 'Fecha de nacimiento',
          type: 'date',
          required: false,
          value: birthday,
          errorMessage: 'Por favor ingresa tu fecha de nacimiento',
        },
        firstName: {
          label: 'Primer nombre',
          type: 'text',
          required: false,
          value: '', // Puedes agregar un valor por defecto si es necesario
        },
        secondName: {
          label: 'Segundo nombre',
          type: 'text',
          required: false,
          value: '', // Puedes agregar un valor por defecto si es necesario
        },
        firstLastName: {
          label: 'Primer apellido',
          type: 'text',
          required: false,
          value: '', // Puedes agregar un valor por defecto si es necesario
        },
        secondLastName: {
          label: 'Segundo apellido',
          type: 'text',
          required: false,
          value: '', // Puedes agregar un valor por defecto si es necesario
        }
      }}
      // If you want to keep your own “onChange” handlers:
      updateOnChange
      onChange={({ input, value }) => {
        if (input === 'cedula') setCedula(value)
        if (input === 'birthday') setBirthday(value)
      }}
      callback={res => {
        // Aquí puedes manejar la respuesta del servidor:
        // p.ej. actualizar tu estado o contexto global
        const saved = res.data.data
        setCedula(saved.cedula)
        setBirthday(saved.birthday)
      }}
    />
  )
}
